import { z } from 'zod';
import { SupportedChainId, config } from '@orionprotocol/sdk';

// eslint-disable-next-line boundaries/no-unknown
import { Feature } from '../../../types';

const { pureEnvPayloadSchema, pureEnvNetworksSchema } = config.schemas;

const uiEnvNetworksSchema = pureEnvNetworksSchema.extend({
  disabledFeatures: z.array(z.nativeEnum(Feature)).optional(),
});

export const envInfoSchema = pureEnvPayloadSchema.extend({
  // UI only params
  defaultNetwork: z.nativeEnum(SupportedChainId).optional(), // UI only param
  atomicSwapSourceNetworkDefault: z.string().optional(),
  isKucoinStyled: z.boolean().optional(),
  whitelist: z.array(z.nativeEnum(Feature)).optional(),
  disabledFeatures: z.array(z.nativeEnum(Feature)).optional(),
  networks: z.record(uiEnvNetworksSchema),
});

export const envSchema = z.record(envInfoSchema);
